export function registerPwaServiceWorker() {
  if (!window.isSecureContext || !("serviceWorker" in navigator)) return;
  async function register() {
    try {
      await navigator.serviceWorker.register("/sw.js", { scope: "/", updateViaCache: "none" });
    } catch (error) {
      console.warn("MetaCard PWA registration failed:", error.name);
    }
  }
  if (document.readyState === "complete") void register();
  else window.addEventListener("load", register, { once: true });
}
